export const ROUTE_PATH = {
    DASHBOARD: "/dashboard",
    HOME: "/",
    TOOLS: "/tools",
    INSTAGRAM: "/creator/link-in-bio-for-instagram",
    TWITTER: "/creator/link-in-bio-for-twitter",
    TIKTOK: "/creator/link-in-bio-for-tiktok",
    LINKEDIN: "/creator/link-in-bio-for-linkedin",
    TSHIRT: "/create/t-shirts",
    CUSTOMIZER: "/create/product/customize",
    INCOME: "/income",
    SETTINGS: "/settings",
    PROFILE: "/settings/profile",
    USERPROFILE: "/profile",
    CUSTOMERS: "/subscribers",
    SUBSCRIBER_DETAIL: "/subscriber/:id",
    BILLING: "/settings/billing",
    PAYMENTS: "/settings/payments",
    NOTIFICATIONS: "/settings/notifications",
    MYSTORE: "/store",
    SHOP: "/shop",
    SHOP_CATEGORIES: "/shop/home",
    CREATOR_STORE: "/creator-store",
    CREATOR_STORE_CATEGORIES: "/creator-store/home",
    DESIGN: "/design",
    PRODUCTS: "/products",
    DESIGNS: "/designs",
    ONBOARDING: "/onboarding",
    LOGIN: "/auth/login",
    CUSTOMER_LOGIN: "/customer/login",
    REGISTER: "/auth/register",
    FORGOT_PASSWORD: "/auth/forgot",
    REFERRALS: "/referrals",    
    CUSTOMPRODUCTS: "/custom-products",
    CUSTOM_TYPE: "/custom/:category",
    CUSTOM_COLLECTION: "/custom/:category/:collectionSlug",
    CUSTOM_PRODUCT: "/custom/:category/:collectionSlug/:productSlug",
    PUBLICSHOP: "/shop",
    SHOP_TYPE: "/shop/:category",
    SHOP_COLLECTION: "/shop/:category/:collectionSlug",
    SHOP_PRODUCT: "/shop/:category/:collectionSlug/:productSlug",
    
    CREATOR_STORE_TYPE: "/creator-store/:category",
    CREATOR_STORE_COLLECTION: "/creator-store/:category/:collectionSlug",
    CREATOR_STORE_PRODUCT: "/creator-store/:category/:collectionSlug/:productSlug",
};

export const STORE_PATH = {
    SHOPDASHBOARD: "/store/dashboard",
    ORDERS: "/view/orders",
    ADD_PRODUCTS: "/store/products",
    VIEW_PRODUCTS: "/view/products",
    COLLECTIONS: "/store/collections",
    CUSTOMERS: "/view/customers",
    CREATORS: "/store/creators",
    CREATOR_DETAILS: "/store/creators/:id",
    READY_MADE_PRODUCTS: "/store/ready-made-products",
    GOOGLE_MERCHANT: "/store/google-merchant",
    FACEBOOK_CATALOG: "/store/facebook-catalog",
    TIKTOK_CATALOG: "/store/tiktok-catalog",
    DESIGNS: "/store/designs",
    DESIGN_CATEGORIES: "/store/design-categories",
    SETTINGS: "/store/settings"
}

export const ROUTE_PRODUCT_PATH = {
    URL_PRODUCT: "/products/add-products/url",
    EDIT_URL_PRODUCT: "/products/edit/url/:id",

    ENGAGEMENT: "/add-products/engagement",
    EDIT_ENGAGEMENT: "/products/edit/engagement/:id",

    IMAGE_PRODUCT: "/products/add-products/image",

    DIGITAL_PRODUCT: "/add-products/digital-product",
    EDIT_DIGITAL_PRODUCT: "/products/edit/digital/:id",

    COACHING_CALL: "/add-products/coaching-call",

    SPARKLE_CONNECT: "/add-products/sparkle-connect",
    SPARKLE_CONNECT_EDIT: "/products/edit/sparkle-connect/:id",

    CUSTOM_PRODUCT: "/add-products/custom-product",
    EDIT_CUSTOM_PRODUCT: "/products/edit/custom/:id",

    TIP_PRODUCT: "/add-products/tip-jar",
    EDIT_TIP_PRODUCT: "/products/edit/tip-jar/:id",

    EMAIL_PRODUCT: "/add-products/email-product",
    EDIT_EMAIL_PRODUCT: "/products/edit/email/:id",

    VIDEO_PRODUCT: "/add-products/video-product",
    EDIT_VIDEO_PRODUCT: "/products/edit/video/:id",

    REFERRAL_PRODUCT: "/add-products/referral-product",
    EDIT_REFERRAL_PRODUCT: "/products/edit/referral/:id",

    APPOINTMENTS: "/add-products/appointments",
    EDIT_APPOINTMENTS: "/products/edit/appointments/:id",

    SPOTIFY: "/add-products/spotify",
    EDIT_SPOTIFY_PRODUCT: '/products/edit/spotify/:id',

    APPLE_MUSIC: "/add-products/apple-music",
    EDIT_APPLE_MUSIC_PRODUCT: "/products/edit/apple-music/:id",

    COURSE_DASHBOARD: "/courses/dashboard",
    COURSE_PRODUCT: "/add-products/course-product",
    EDIT_COURSE_PRODUCT: "/products/edit/course/:id",
    COURSE_ANALYTICS: "/courses/:id/analytics",

    RAFFLE_SETUP: "/add-products/raffle-setup",
    RAFFLE_DASHBOARD: "/raffles/dashboard",
    RAFFLE_OVERVIEW: "/raffles/overview",
    EDIT_RAFFLE: "/products/edit/raffle/:id",
};

export const ROUTE_LEGAL_PATH = {
    LEGAL: "/legal",
    PRIVACY_POLICY: "/legal/privacy-policy",
    TERMS_OF_SERVICE: "/legal/terms-of-service",
    COOKIE_POLICY: "/legal/cookie-policy",
    REFUND_POLICY: "/legal/refund-policy",
    DATA_DELETION_POLICY: "/legal/data-deletion-policy",
    ACCEPTABLE_USE_POLICY: "/legal/acceptable-use-policy",
    COPYRIGHT_INFRINGEMENT: "/legal/copyright-infringement-dmca",
};